// extracted by mini-css-extract-plugin
export default {"cls1":"VeloStatusIndicator-LoadingIcon_cls1__oUk7x","cls2":"VeloStatusIndicator-LoadingIcon_cls2__rQMI8 VeloStatusIndicator-LoadingIcon_cls1__oUk7x"};